import { render, staticRenderFns } from "./select-lens-type.vue?vue&type=template&id=0a6d61d6&scoped=true"
import script from "./select-lens-type.vue?vue&type=script&lang=js"
export * from "./select-lens-type.vue?vue&type=script&lang=js"
import style0 from "./select-lens-type.vue?vue&type=style&index=0&id=0a6d61d6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6d61d6",
  null
  
)

export default component.exports